import {
  ContentVisibility,
  YoutubeVideoProvider,
  RootsTechBrightcoveVideoProvider,
  WebinarVideoProvider,
  ExpoThumbnailImage,
} from '@fs/zion-rootstech'

export const ExpoVideoDetail = `
  ${ExpoThumbnailImage}
  ${ContentVisibility}
  ${WebinarVideoProvider}
  ${RootsTechBrightcoveVideoProvider}
  ${YoutubeVideoProvider}
  fragment ExpoVideoDetail on VideoDetail {
    contentLocale
    headline
    id
    subHeadline
    thumbnail {
      ...ExpoThumbnailImage
    }
    url
    videoDuration
    videoProvider {
      ...YoutubeVideoProvider
      ...RootsTechBrightcoveVideoProvider
      ...WebinarVideoProvider
    }
    visibility {
      ...ContentVisibility
    }
  }
`
